// Taboola defaults for rugby, all editions.
//
// Notes:
// 1. 'team' => 'clubhouse'

export default {
  'team': {
    'type': 'other',
    'mode': 'thumbnails-1x3',
    'container': 'taboola-right-rail-thumbnails',
    'target_type': 'mix'
  }
}



// WEBPACK FOOTER //
// ../app/lib/utils/editions/config/taboola.js